module.exports = __webpack_public_path__ + "fonts/fa-regular-400.7a9d78e9.woff";